export const LINE_SINGLE = ["#5B0F74"];

export const LINE_SINGLE_AREA_COLOR = ['rgba(91,15,116,0.7)', 'rgba(233,233,233,0.2)'];

export const PIE_FOCUS_USABLE = ["#5B0F74", "#E5EAF1"];

export const MAIN_COLOR_PALETTE = [
    '#1E88E5',
    '#FFA726',
    '#26A69A',
    '#EF5350',
    '#3949AB',
    '#66BB6A',
    '#5B0F73',
    '#8E24AA',
    '#AB47BC',
    '#CE93D8',
];

export const MAIN_LINEAR_COLOR_PALETTE = [
    ['rgba(120,190,255,1)', 'rgba(30,136,229,1)'],
    ['rgba(255,220,120,1)', 'rgba(255,167,38,1)'],
    ['rgba(120,230,210,1)', 'rgba(38,166,154,1)'],
    ['rgba(255,150,140,1)', 'rgba(239,83,80,1)'],
    ['rgba(150,170,255,1)', 'rgba(57,73,171,1)'],
    ['rgba(180,255,180,1)', 'rgba(102,187,106,1)'],
    ['rgba(200,120,230,1)', 'rgba(91,15,115,1)'],
    ['rgba(220,140,255,1)', 'rgba(142,36,170,1)'],
    ['rgba(235,170,255,1)', 'rgba(171,71,188,1)'],
    ['rgba(245,200,255,1)', 'rgba(206,147,216,1)'],
];
